export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="mb-8 flex flex-wrap items-end justify-between gap-4 border-b pb-6">
      <div className="min-w-0 space-y-2">
        {eyebrow && <p className="text-xs font-medium tracking-[0.08em] text-muted-foreground uppercase">{eyebrow}</p>}
        <h1 className="font-serif text-3xl font-semibold tracking-tight text-balance sm:text-[2.125rem]">{title}</h1>
        {description && <p className="max-w-2xl leading-relaxed text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  )
}
